import * as React from 'react';
import { Redirect } from 'react-router-dom';

function PageNotFound(): JSX.Element {
  React.useEffect(() => {
    //TODO: show toast
    console.log('page not found' + window.location.href);
  }, []);
  return <Redirect to="/home" />;
}

export default PageNotFound;
